import { useFeatureToggles } from './useFeatureToggles'

export default useFeatureToggles
